import { useState, useEffect } from "react";
import type { ReactNode } from "react";
import { MenuIcon, CloseIcon } from "../../../shared/margincalculator/components/icons/Icon";
import "./MarginCalculatorLayout.scss";

interface MarginCalculatorLayoutProps {
  sidebar: ReactNode;
  children: ReactNode;
}

function MarginCalculatorLayout({ sidebar, children }: MarginCalculatorLayoutProps) {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const toggleSidebar = () => setIsSidebarOpen((previous) => !previous);

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth > 768) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (isSidebarOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isSidebarOpen]);

  return (
    <div
      className={`margin-layout ${isSidebarOpen ? "margin-layout--sidebar-open" : ""}`}
    >
      <aside className="margin-layout__sidebar">
        <div className="margin-layout__sidebar-header">
          <button
            type="button"
            className="margin-layout__toggle margin-layout__toggle--close"
            onClick={toggleSidebar}
            aria-label="Margenkalkulator-Navigation schließen"
          >
            <CloseIcon />
          </button>
        </div>
        {sidebar}
      </aside>

      {isSidebarOpen && (
        <div className="margin-layout__overlay" onClick={toggleSidebar} />
      )}

      <div className="margin-layout__main">
        <header className="margin-layout__header">
          <button
            type="button"
            className="margin-layout__toggle"
            onClick={toggleSidebar}
            aria-label="Margenkalkulator-Navigation öffnen"
          >
            <MenuIcon />
          </button>
        </header>
        <div className="margin-layout__content">
          <div className="margin-layout__content-main">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

export default MarginCalculatorLayout;
